module.exports = __webpack_public_path__ + "static/img/clickin2.e37f7b48.png";